import axios from "axios"

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
})

api.interceptors.response.use((response) => {
  handleError(response)
  return response
}, (error) => {
  handleError(error.response)
  return Promise.reject(error)
})

api.setToken = (token) => {
  localStorage.setItem("dora.auth", token)
  api.defaults.headers.common.Authorization = `Bearer ${token}`
}

api.removeToken = () => {
  localStorage.removeItem("dora.auth", token)
  delete api.defaults.headers.common.Authorization
}

const token = localStorage.getItem("dora.auth")

if (token) {
  api.setToken(token)
}

const handleError = (response) => {
  if (
    response.config.url !== "/is-authenticated" &&
    response &&
    response.data &&
    response.data.error &&
    response.data.error.description
  ) {
    alert(response.data.error.description)
  }
}

export default api
